// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "micro-base-static/css/" + (chunkId === 699 ? "system" : chunkId) + "." + {"320":"6adc8750","699":"f8683ac4","960":"af18a9f7"}[chunkId] + ".chunk.css";
};